export const ShirtCascade = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="32"
    viewBox="0 0 42 32"
    fill="none"
  >
    <path
      opacity="0.25"
      d="M32.7328 2.66699L38.5728 4.61366C39.1763 4.81472 39.688 5.22488 40.0156 5.77012C40.3433 6.31535 40.4652 6.95975 40.3595 7.58699L39.5861 12.2137C39.5354 12.5269 39.3745 12.8117 39.1326 13.017C38.8907 13.2223 38.5834 13.3346 38.2661 13.3337H35.3995V26.667C35.3995 27.3742 35.1185 28.0525 34.6184 28.5526C34.1183 29.0527 33.44 29.3337 32.7328 29.3337"
      stroke="#494949"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M26.3336 2.66699L32.1736 4.61366C32.777 4.81472 33.2888 5.22488 33.6164 5.77012C33.944 6.31535 34.066 6.95975 33.9602 7.58699L33.1869 12.2137C33.1361 12.5269 32.9753 12.8117 32.7334 13.017C32.4914 13.2223 32.1842 13.3346 31.8669 13.3337H29.0002V26.667C29.0002 27.3742 28.7193 28.0525 28.2192 28.5526C27.7191 29.0527 27.0408 29.3337 26.3336 29.3337"
      stroke="#494949"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.7736 4.61366L19.9336 2.66699C19.9336 4.08148 19.3717 5.43803 18.3715 6.43823C17.3713 7.43842 16.0148 8.00033 14.6003 8.00033C13.1858 8.00033 11.8292 7.43842 10.829 6.43823C9.82884 5.43803 9.26694 4.08148 9.26694 2.66699L3.42694 4.61366C2.82345 4.81472 2.31171 5.22488 1.98408 5.77012C1.65645 6.31535 1.53451 6.95975 1.64027 7.58699L2.41361 12.2137C2.46437 12.5269 2.62518 12.8117 2.86713 13.017C3.10908 13.2223 3.4163 13.3346 3.73361 13.3337H6.60027V26.667C6.60027 28.1337 7.80027 29.3337 9.26694 29.3337H19.9336C20.6409 29.3337 21.3191 29.0527 21.8192 28.5526C22.3193 28.0525 22.6003 27.3742 22.6003 26.667V13.3337H25.4669C25.7842 13.3346 26.0915 13.2223 26.3334 13.017C26.5754 12.8117 26.7362 12.5269 26.7869 12.2137L27.5603 7.58699C27.666 6.95975 27.5441 6.31535 27.2165 5.77012C26.8888 5.22488 26.3771 4.81472 25.7736 4.61366Z"
      stroke="#494949"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
